import array from './array';
import languages from './languages';
import promise from './promise';
import tours from './tours';

export default Object.freeze({
    array,
    promise,
    languages,
    tours,
});
